export type SortDirection = 'asc' | 'desc';

export type Comparator<T> = (a: T, b: T) => number;

export type ColumnKey<TData> = keyof TData;

export type ColumnDef<TData> = {
	[K in ColumnKey<TData>]: {
		key: K;
		header: React.ReactNode;
		render: (item: TData) => React.ReactNode;
		compare?: Comparator<TData[K]>;
		textAlign?: 'start' | 'center' | 'end';
	};
}[ColumnKey<TData>];

export function sortRows<TData>(rows: readonly TData[], column: ColumnDef<TData>, direction: SortDirection): TData[] {
	if (!column.compare)
		return [...rows];

	const multiplier = direction === 'asc' ? 1 : -1;

	return [...rows].sort((a, b) => column.compare!(a[column.key], b[column.key]) * multiplier);
}